<template>
	<div>
	<div class="row">
	</div>
	<div class="row">
		<div class="col-md-9">
			<div id="jumbotron-mentors" class="jumbotron border">
				<h1 class="display-4">Find a Coding Mentor</h1>
				<p class="lead">Find a high-quality mentor to help you level up faster.</p>
				<hr class="my-4">
				<p> Great for university students, boot camp attendees, and entry-level software engineers.</p>
				<router-link to="/mentors" class="btn btn-primary btn-lg" role="button">Learn More</router-link>
			</div>
			<div id="jumbotron-products" class="jumbotron border">
				<h1 class="display-4"> Our Books and Tutorials </h1>
				<p class="lead"> Acquire new skills with our products from the Man vs. Code series. </p>
				<hr class="my-4">
				<router-link to="/products" class="btn btn-primary btn-lg" role="button">Learn More</router-link>
			</div>
			<div id="jumbotron-consulting" class="jumbotron border">
				<h1 class="display-4"> Need help with your project? </h1>
				<p class="lead"> Let our experts create your website or mobile app. </p>
				<hr class="my-4">
				<router-link to="/consulting" class="btn btn-primary btn-lg" role="button">Learn More</router-link>
			</div>
		</div>
		<div class="col-md-3">
			<p> Becoming a better coder involves <i>three things</i>&mdash;coding, debugging, and reading the code of others. Our organization helps
			coders acquire new skills and become stronger software developers through our mentorship and books. </p>
			<h2> News </h2>
			<ul class="news-list">
				<li class="news-item"><span class="news-date">2020-06-15</span>&mdash;<span class="news-text">A new book is in the works regarding how to develop command-line utilities.</span></li>
				<li class="news-item"><span class="news-date">2020-01-01</span>&mdash;<span class="news-text">Happy New Year!</span></li>
			</ul>
		</div>
	</div>
	</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		//HelloWorld
	},
}
</script>

<style>
#jumbotron-mentors {
	background-image: url('/img/home-mentors.jpg');
}
#jumbotron-products {
	background-image: url('/img/home-books.jpg');
}
#jumbotron-consulting {
	background-image: url('/img/home-consulting.jpg');
}

ul.news-list {
	list-style: none;
	margin: 0 0;
	padding: 0 0;
}
li.news-item {
	border-bottom: 1px solid #5a99a6;
}

.news-date {
	display: block;
	float: left;
	vertical-align: bottom;

}
.news-text {
	vertical-align: center;
}
</style>
